import { MobileOfferCatalogEntry, MobileOfferProvider, MobileOfferStoreStatus } from '@numeo/types'
import { Tag } from 'lucide-react'
import { customerOfferLabel, customerOfferSecondaryClass, customerStoreName } from './customer-offer-utils'
import { OfferPrices } from './OfferPrices'
import { OfferNotice } from './ui'

export function CustomerOfferSummary({ offer, provider }: { offer: MobileOfferCatalogEntry; provider: MobileOfferProvider }) {
    const store = offer.stores[provider]
    const prices = store.status === MobileOfferStoreStatus.READY ? store.prices : undefined
    return (
        <div className="space-y-4">
            <div className="flex items-start gap-3">
                <span className="rounded-lg bg-blue-50 p-2 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">
                    <Tag className="h-5 w-5" />
                </span>
                <div>
                    <h3 className="font-semibold">{customerOfferLabel(offer)}</h3>
                    <p className={`${customerOfferSecondaryClass} mt-1`}>
                        {customerStoreName(provider)} · {offer.terms.environment === 'sandbox' ? 'Test' : 'Real'} transactions
                    </p>
                </div>
            </div>
            <p className={customerOfferSecondaryClass}>
                Includes the initial payment. Regular monthly pricing resumes after {offer.terms.discountedPeriods} payments.
            </p>
            {prices?.length ? (
                <OfferPrices prices={prices} periods={offer.terms.discountedPeriods} />
            ) : (
                <OfferNotice error>Verified regional prices are unavailable. Refresh the offer before assigning it.</OfferNotice>
            )}
            <p className={customerOfferSecondaryClass}>
                Verified store prices are shown above. The store purchase sheet confirms the final price and availability for the customer.
            </p>
        </div>
    )
}
